import { Box, VStack, Text, IconButton } from '@chakra-ui/react';
import { MdVolumeUp as VolumeUpIcon } from 'react-icons/md';
import ChatMessageContent from './ChatMessageContent';

interface ChatMessageProps {
  role: 'user' | 'assistant';
  content: string;
  isFirstOfRole: boolean;
  onReadAloud?: (text: string) => void;
}

export default function ChatMessage({
  role,
  content,
  isFirstOfRole,
  onReadAloud,
}: ChatMessageProps) {
  return (
    <Box
      display="flex"
      justifyContent={role === 'user' ? 'flex-end' : 'flex-start'}
      alignItems="flex-start"
    >
      <VStack
        align={role === 'user' ? 'flex-end' : 'flex-start'}
        gap={1}
        maxW="85%"
      >
        {isFirstOfRole && (
          <Text
            fontSize="xs"
            fontWeight="semibold"
            fontFamily="body"
            color={role === 'user' ? 'text.muted' : 'accent.secondary'}
            px={2}
          >
            {role === 'user' ? 'You' : 'Chef Assistant'}
          </Text>
        )}
        <Box
          bg={role === 'user' ? 'accent.emphasis' : 'accent.secondarySubtle'}
          border="none"
          p={3}
          borderRadius="xl"
          borderBottomRightRadius={role === 'user' ? 'sm' : 'xl'}
          borderBottomLeftRadius={role === 'user' ? 'xl' : 'sm'}
          w="100%"
        >
          {role === 'user' ? (
            <Text
              fontSize="sm"
              lineHeight="tall"
              color="white"
              fontFamily="body"
              whiteSpace="pre-wrap"
            >
              {content}
            </Text>
          ) : (
            <ChatMessageContent content={content} />
          )}
          {role === 'assistant' && onReadAloud && (
            <Box display="flex" justifyContent="flex-end" mt={2} mr={-1} mb={-1}>
              <IconButton
                aria-label="Read aloud"
                size="xs"
                variant="ghost"
                color="accent.secondary"
                _hover={{ color: 'accent.secondaryHover', bg: 'transparent' }}
                onClick={() => onReadAloud(content)}
              >
                <VolumeUpIcon />
              </IconButton>
            </Box>
          )}
        </Box>
      </VStack>
    </Box>
  );
}
